import React from 'react';
import { Link } from 'react-router-dom';
import { AppHeader, AppFooter } from 'containers';
import { Box, Button, Typography } from '@material-ui/core';
import { t } from 'utils/common';
import { privateRoute } from 'routes';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { isError: true };
  }

  render() {
    if (this.state.isError) {
      return (
        <div className='App Private-Layout'>
          <AppHeader />
          <div className='App-Body'>
            <Box mt={10} textAlign='center'>
              <Typography variant='h5'>{t('Some errors have occurred')}</Typography>
              <Typography variant='h6' color='textSecondary' gutterBottom>
                {t('Please try again later')}
              </Typography>
              <Button
                variant='outlined'
                component={Link}
                to={privateRoute.explore.path}
                onClick={() => {
                  this.setState({ isError: false });
                  window.location.reload();
                }}
              >
                <Typography>{t('Refresh')}</Typography>
              </Button>
            </Box>
          </div>
          <AppFooter />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
